export default "__VITE_ASSET__XmyWFif1__"